<template>
  <div class="order-flow-container">
    <div class="block">
      <div class="radio">
        排序：
        <el-radio-group v-model="reverse">
          <el-radio :label="true">正序</el-radio>
          <el-radio :label="false">倒序</el-radio>
        </el-radio-group>
      </div>
      <el-timeline :reverse="reverse" :style="{ height: timelineHeight }" class="record-timeline">
        <el-timeline-item
            v-for="(activity, index) in records"
            :key="index"
            :color="selectColor(activity)"
            :timestamp="activity.createTime">
          <h3>{{$dict.nameOf('order_status', activity.status)}}</h3>
          <p>
            <span style="margin-right: 15px;">{{ activity.creator }}</span>
            <span style="margin-right: 15px;">{{ $dict.nameOf('flow_record_result', activity.result) }}</span>
            <span>{{ activity.content }}</span>
          </p>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>
import {hasPer} from "@/utils/common";
import {auditRecord} from "@/api/sys/flow/audit";

export default {
  name: "OrderFlowRecord",
  components: {},
  props: {
    orderNo: {
      type: String,
      require: true,
      default: ''
    },
    height: {
      type: Number,
      require: true,
      default: 500
    }
  },
  data() {
    return {
      reverse: false,
      records: []
    };
  },
  mounted() {
    this.getRecordData();
  },
  computed: {
    timelineHeight() {
      return `${this.height}px`;
    }
  },
  methods: {
    hasPer,
    getRecordData(){
      auditRecord(this.orderNo).then(res => {
        this.records = res;
      });
    },
    selectColor(row){
      switch (row.result) {
        case 'pass':
          return '#67C23A';
        case 'reject':
          return '#F56C6C';
        case 'rollback':
          return '#E6A23C';
        default:
          return '#409EFF';
      }
    }
  }
}
</script>

<style scoped>
.block {
  padding: 10px;
}
.radio {
  margin-bottom: 20px;
}
.record-timeline{
  overflow-y: auto;
}
</style>
